// extracted by mini-css-extract-plugin
export default {"selectedNameAutoComplete":"style_selectedNameAutoComplete__Txux8","displayAlign":"style_displayAlign__5a2Np","input":"style_input__daosv"};